import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import Cookie from 'js-cookie';

Vue.use(VueRouter);

const API = {
  LOGIN: `${process.env.VUE_APP_API_BASE_URL}/user/login`,
  CAN_VOTE: `${process.env.VUE_APP_API_BASE_URL}/user/can_vote?uid=`,
};

const END_DATE = new Date(2021, 9, 13, 12, 0, 0);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/ended',
    name: 'ended',
    component: () => import('../views/Ended.vue'),
  },
  {
    path: '/voted',
    name: 'voted',
    component: () => import('../views/Voted.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.name === 'ended') return next();

  if (!Cookie.get('user_id') && to.path !== '/') return next({ path: '/' });

  const user_id = Cookie.get('user_id') || await axios.get(API.LOGIN);
  const date = new Date();

  const midnight = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
  if (!Cookie.get('user_id')) Cookie.set('user_id', user_id.data.uid, { expires: midnight });

  const can_vote = await axios.get(API.CAN_VOTE + Cookie.get('user_id'), {
    uid: Cookie.get('user_id'),
  });

  if (!can_vote.data.response && to.path !== '/voted') return next({ path: '/voted' });

  if (can_vote.data.response && to.path !== '/') return next({ path: '/' });

  if (Date.now() > END_DATE && to.path !== '/ended') return next({ path: '/ended' });
  next();
});

export default router;
